// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/management/resources/user_tenant.proto (package gx.management.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_management_resources_tenant } from "./tenant_pb.js";

/**
 * Describes the file services/management/resources/user_tenant.proto.
 */
export const file_services_management_resources_user_tenant = /*@__PURE__*/
  fileDesc("Ci9zZXJ2aWNlcy9tYW5hZ2VtZW50L3Jlc291cmNlcy91c2VyX3RlbmFudC5wcm90bxIXZ3gubWFuYWdlbWVudC5yZXNvdXJjZXMinAIKElVzZXJUZW5hbnRSZXNvdXJjZRIKCgJpZBgBIAEoCRI0CgZzdGF0dXMYAiABKA4yJC5neC5kYXRhYmFzZS5tb2RlbHMuVXNlclRlbmFudFN0YXR1cxI/CgxhY2Nlc3NfbGV2ZWwYAyABKA4yKS5neC5kYXRhYmFzZS5tb2RlbHMuVXNlclRlbmFudEFjY2Vzc0xldmVsEkoKFXByb3ZpZGVkX2pvYl9mdW5jdGlvbhgEIAEoDjIrLmd4LmRhdGFiYXNlLm1vZGVscy5Vc2VyUHJvdmlkZWRKb2JGdW5jdGlvbhI3CgZ0ZW5hbnQYBSABKAsyJy5neC5tYW5hZ2VtZW50LnJlc291cmNlcy5UZW5hbnRSZXNvdXJjZUL3AQobY29tLmd4Lm1hbmFnZW1lbnQucmVzb3VyY2VzQg9Vc2VyVGVuYW50UHJvdG9QAVpJZ2l0aHViLmNvbS9nYWxheHktaW8vZ3gvc2hhcmVkL2dvL2NvbnRyYWN0cy9zZXJ2aWNlcy9tYW5hZ2VtZW50L3Jlc291cmNlc6ICA0dNUqoCF0d4Lk1hbmFnZW1lbnQuUmVzb3VyY2VzygIXR3hcTWFuYWdlbWVudFxSZXNvdXJjZXPiAiNHeFxNYW5hZ2VtZW50XFJlc291cmNlc1xHUEJNZXRhZGF0YeoCGUd4OjpNYW5hZ2VtZW50OjpSZXNvdXJjZXNiBnByb3RvMw", [file_services_database_models_public, file_services_management_resources_tenant]);

/**
 * Describes the message gx.management.resources.UserTenantResource.
 * Use `create(UserTenantResourceSchema)` to create a new message.
 */
export const UserTenantResourceSchema = /*@__PURE__*/
  messageDesc(file_services_management_resources_user_tenant, 0);

